import { lineString, polygon } from "@turf/helpers";
import { toMercator, toWgs84 } from "@turf/projection";
import lineOffset from "@/libs/line-offset";

export const getDiagramGeojson = (features, config, id, store) => {
  const { field, maxValue, width } = config;
  const diagramFeatures = [];

  const getFeatureValue = (f, fieldName) => {
    const { objectFields } = store.state.calculations;
    const fields = objectFields[id];
    const fieldConfig = fields.find(f => f.title === fieldName);

    if (fieldConfig && fieldConfig.calc_field) {
      return (
        Math.abs(f.properties[`link_calculation_results_${fieldName}`]) || 0
      );
    }

    return Math.abs(f.properties[fieldName]) || 0;
  };

  features.forEach(f => {
    const value = getFeatureValue(f, field);
    const weight = field ? (value / maxValue) * width : width;

    if (isFinite(weight) && weight > 0) {
      const initial = f.geometry.coordinates;
      const line = lineString(initial);
      const mercLine = toMercator(line);
      const lineCoords = mercLine.geometry.coordinates;
      const offset = lineOffset(mercLine, weight, { units: "metres" });

      if (offset) {
        const offsetCoords = offset.geometry.coordinates;
        offsetCoords.reverse();
        const mercCoordinates = [
          [...lineCoords, ...offsetCoords, lineCoords[0]]
        ];
        const coordinates = toWgs84(polygon(mercCoordinates)).geometry
          .coordinates;

        diagramFeatures.push({
          type: "Feature",
          properties: { ...f.properties },
          geometry: {
            type: "Polygon",
            coordinates
          }
        });
      }
    }
  });

  return { type: "FeatureCollection", features: diagramFeatures };
};
